import React from 'react';
import { Card, Stack, Box, Skeleton, Divider } from '@mui/material';

const TutorCardSkeleton: React.FC = () => {
  return (
    <Card
      sx={{
        padding: '20px',
        borderRadius: '20px',
        boxShadow: '0px 14px 40px 0px #6E9DB22E',
      }}
    >
      <Stack spacing={1}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={1}>
            <Skeleton variant="circular" width={50} height={50} />
            <Box>
              <Skeleton variant="text" width={100} height={24} />
              <Skeleton variant="rectangular" width={20} height={20} />
            </Box>
          </Box>
          <Skeleton variant="text" width={80} height={24} />
        </Box>

        {/* Rating and Experience */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          padding="10px"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Skeleton variant="rectangular" width={20} height={20} />
            <Skeleton variant="text" width={60} height={20} />
            <Skeleton variant="text" width={80} height={20} />
          </Box>
          <Box display="flex" gap={1}>
            <Skeleton variant="text" width={60} height={20} />
            <Skeleton variant="text" width={80} height={20} />
          </Box>
        </Box>

        <Divider flexItem variant="middle" sx={{ borderStyle: 'dashed' }} />

        {/* Bio */}
        <Box padding="10px">
          <Skeleton variant="text" height={20} width="100%" />
          <Skeleton variant="text" height={20} width="95%" />
          <Skeleton variant="text" height={20} width="80%" />
        </Box>

        {/* Languages */}
        <Box padding="10px" display="flex" gap={1}>
          <Skeleton variant="text" width={60} height={20} />
          <Skeleton variant="text" width={100} height={20} />
        </Box>

        {/* Lessons and Free Trial */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Skeleton variant="text" width="40%" height={24} />
          <Skeleton
            variant="rectangular"
            width={100}
            height={35}
            sx={{ borderRadius: '35px' }}
          />
        </Box>
      </Stack>
    </Card>
  );
};

export default TutorCardSkeleton;
